Prism.languages.diff={coord:[/^(?:\*{3}|-{3}|\+{3}).*$/m,/^@@.*@@$/m,/^\d+.*$/m],deleted:/^[-<].*$/m,inserted:/^[+>].*$/m,diff:{pattern:/^!(?!!).+$/m,alias:"important"}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/prismjs/components/prism-diff.min.js
// module id = 7jaG
// module chunks = 0